import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Employment } from '../../../models/customer.model';
import { DataTableService } from '../../../modules/UIKit/components/dataTable/dataTable.service';
import { EmploymentService } from '../../../services/employment/employment.service';

@Component({
  selector: 'app-employment',
  templateUrl: './employment.component.html',
  styleUrls: ['./employment.component.css']
})
export class EmploymentComponent implements OnInit {

  addEditDialog = false;
  modalTitle = '';
  labels = {};

  constructor(
    public employmentService: EmploymentService,
    private srvDataTable: DataTableService,
    private translateService: TranslateService
    ) {
  }

  ngOnInit() {

    this.translateService.get([
      'employmentList.addTitle',
      'employmentList.editTitle'
    ]).subscribe((res) => {
      this.labels['add_title'] = res['employmentList.addTitle'];
      this.labels['edit_title'] = res['employmentList.editTitle'];
    });

    this.reloadList()
  }

  reloadList() {
    this.employmentService.getList().subscribe();
  }

  showAddOrEditDialog(data): void {
    this.modalTitle = data == null ? this.labels['add_title'] : this.labels['edit_title'];
    this.employmentService.employmentEditing = data == null ? new Employment() : data;
    this.addEditDialog = true;
  }

  closeAddDialog() {
    this.modalTitle = '';
    this.employmentService.employmentEditing = null;
    this.addEditDialog = false;
  }

  delete(record): void {
    this.employmentService.delete(record).subscribe(() => {
      this.reloadList();
    });
  }

  employmentAdded($event): void {
    this.employmentService.post($event).subscribe(() => {
      this.srvDataTable.get('dt_employment').showDetail = false;
      this.employmentService.employmentEditing = null;
      this.reloadList();
      this.addEditDialog = false;
    });
  }

  employmentUpdated($event): void {
    this.employmentService.put($event, this.employmentService.employmentEditing.id).subscribe(() => {
        this.srvDataTable.get('dt_employment').showDetail = false;
        this.employmentService.employmentEditing = null;
        this.reloadList();
        this.addEditDialog = false;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/employment/employment.component.ts